module.exports = __webpack_public_path__ + "img/equipment-06@2x.bc049e23.png";